import { createStackNavigator } from '@react-navigation/stack'
import { titleCase } from '../../comps/CustomHeader/headerFunctionHelpers'
import { HeaderLeft } from '../../comps/MobileCustomHeader/HeaderLeft'
import { screenTransition } from '../../util/common'
import { isSmallDevice } from '../../util/util'
import { Routes } from '../routes'

import AddUser from '../../screens/Settings/UserManagementNew/AddUser'
import EditUser from '../../screens/Settings/UserManagementNew/EditUser'
import Intro from '../../screens/Settings/UserManagementNew/Intro'
import ManageUsersNew from '../../screens/Settings/UserManagementNew/ManageUsers'
import ViewUserDetail from '../../screens/Settings/UserManagementNew/ViewUserDetail'

const UserManagmentScreenArray = [
  {
    name: Routes.USER_MANAGEMENT.VIEW_USERS,
    comp: ManageUsersNew,
    title: 'Manage users',
  },
  {
    name: Routes.USER_MANAGEMENT.INTRO,
    comp: Intro,
    title: '',
  },
  {
    name: Routes.USER_MANAGEMENT.ADD_USER_MOBILE,
    comp: AddUser,
    title: 'Add user',
  },
  {
    name: Routes.USER_MANAGEMENT.USER_DETAILS_MOBILE,
    comp: ViewUserDetail,
    title: '',
  },
  {
    name: Routes.USER_MANAGEMENT.EDIT_USER_ROLE_MOBILE,
    comp: EditUser,
    title: 'Edit user details',
  },
]

const Stack = createStackNavigator()

export const UserManagment = (props: any) => {
  const { params } = props?.route

  return (
    <Stack.Navigator screenOptions={{ headerBackTitleVisible: false, headerMode: 'screen', ...screenTransition }}>
      {UserManagmentScreenArray?.map((item) => {
        return (
          <Stack.Screen
            key={item?.name}
            name={item?.name}
            component={item?.comp}
            options={
              isSmallDevice()
                ? () => {
                    return {
                      headerLeft: () => <HeaderLeft />,
                      headerStyle: { borderBottomColor: 'rgba(0,0,0,0)' },
                      headerTintColor: '#fff',
                      headerBackVisible: true,
                      headerTransparent: true,
                      title: titleCase(item?.title ?? undefined),
                      headerTitleStyle: {
                        fontSize: 16,
                        fontFamily: 'JioType-Bold',
                      },
                    }
                  }
                : { headerShown: false }
            }
          />
        )
      })}
    </Stack.Navigator>
  )
}
